export const VERIFY_EMAIL = 'VERIFY_EMAIL';

export const emailVerify = (userId, email, token) => ({
  type: VERIFY_EMAIL,
  userId,
  email,
  token,
});

export default {
  emailVerify,
};
